import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { fetchAuthSession } from "@aws-amplify/auth";

const API_BASE_URL = "https://api.cupvisor.org";

function Header({ user, signOut }) {
  const [roles, setRoles] = useState([]);
  const [roleMessage, setRoleMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadRoles() {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        const response = await fetch(`${API_BASE_URL}/auth/groups`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error(`Auth groups endpoint returned status ${response.status}`);
        }
        const data = await response.json();
        const fetchedRoles = data.roles || [];
        setRoles(fetchedRoles);
        setRoleMessage(
          fetchedRoles.length === 0 ? "No roles assigned" : fetchedRoles.join(", ")
        );
      } catch (err) {
        console.error("Error fetching roles:", err);
        setRoleMessage("Error fetching roles");
      } finally {
        setLoading(false);
      }
    }
    loadRoles();
  }, []);

  return (
    <>
      {/* Home Dropdown */}
      <Dropdown style={{ position: "fixed", top: "10px", left: "10px", zIndex: 1000 }}>
        <Dropdown.Toggle
          id="home-dropdown"
          className="btn"
          style={{
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #ff66cc, #9933ff)",
            boxShadow: "0 0 10px rgba(255, 102, 204, 0.8)",
            border: "none",
            transition: "all 0.3s ease",
          }}
          title="Home"
        >
          <i className="bi bi-house-fill" style={{ fontSize: "1.5rem", color: "#ffffff" }}></i>
        </Dropdown.Toggle>
        <Dropdown.Menu
          align="start"
          style={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            marginTop: "8px"
          }}
        >
          {loading ? (
            <Dropdown.ItemText style={{ color: "#ffffff" }}>
              Loading roles...
            </Dropdown.ItemText>
          ) : (
            <>
              {roles.includes("Admin") && (
                <Dropdown.Item
                  as={Link}
                  to="/admin"
                  style={{
                    color: "#ffffff",
                    background: "linear-gradient(135deg, #ff66cc, #9933ff)",
                    borderRadius: "6px",
                    margin: "0.5rem 0",
                    textAlign: "center",
                    padding: "8px 12px",
                    transition: "all 0.3s ease",
                  }}
                >
                  Admin Portal
                </Dropdown.Item>
              )}
              {roles.includes("Vendor") && (
                <Dropdown.Item
                  as={Link}
                  to="/vendor_portal"
                  style={{
                    color: "#ffffff",
                    background: "linear-gradient(135deg, #ff66cc, #9933ff)",
                    borderRadius: "6px",
                    margin: "0.5rem 0",
                    textAlign: "center",
                    padding: "8px 12px",
                    transition: "all 0.3s ease",
                  }}
                >
                  Vendor Portal
                </Dropdown.Item>
              )}
              {roles.includes("User") && (
                <Dropdown.Item
                  as={Link}
                  to="/users"
                  style={{
                    color: "#ffffff",
                    background: "linear-gradient(135deg, #ff66cc, #9933ff)",
                    borderRadius: "6px",
                    margin: "0.5rem 0",
                    textAlign: "center",
                    padding: "8px 12px",
                    transition: "all 0.3s ease",
                  }}
                >
                  User Portal
                </Dropdown.Item>
              )}
              {roles.length === 0 && (
                <Dropdown.ItemText style={{ color: "#ffcc00" }}>
                  Please contact support if you believe you should have a role.
                </Dropdown.ItemText>
              )}
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {/* Settings Dropdown */}
      <Dropdown style={{ position: "fixed", top: "10px", right: "10px", zIndex: 1000 }}>
        <Dropdown.Toggle
          id="settings-dropdown"
          className="btn"
          style={{
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #ffcc00, #ff66cc)",
            boxShadow: "0 0 10px rgba(255, 204, 0, 0.8)",
            border: "none",
            transition: "all 0.3s ease",
          }}
          title="Settings"
        >
          <i className="bi bi-gear-fill" style={{ fontSize: "1.5rem", color: "#ffffff" }}></i>
        </Dropdown.Toggle>
        <Dropdown.Menu
          align="end"
          style={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            marginTop: "8px"
          }}
        >
          {user ? (
            <>
              <Dropdown.ItemText style={{ 
                color: "#ffffff",
                fontWeight: "bold" , 
                background: "linear-gradient(135deg,rgb(156, 121, 168), #9933ff)",
                transition: "all 0.3s ease",
                textAlign: "center",
                borderRadius: "8px",
                }}>
                Hello, {user.signInDetails?.mail || "User"}
              </Dropdown.ItemText>
              <Dropdown.Divider style={{ backgroundColor: "#ffcc00" }} />
              <Dropdown.Item
                onClick={signOut}
                style={{
                  color: "#ffffff",
                  background: "linear-gradient(135deg, #ff66cc, #9933ff)",
                  borderRadius: "6px",
                  textAlign: "center",
                  padding: "8px 12px",
                  transition: "all 0.3s ease",
                }}
              >
                Sign Out
              </Dropdown.Item>
            </>
          ) : (
            <Dropdown.ItemText style={{ color: "#ffcc00" }}>
              Not logged in
            </Dropdown.ItemText>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {/* Additional Styling for Hover Effects and Responsive Positioning */}
      <style>
        {`
          .btn:hover {
            transform: scale(1.1);
            box-shadow: 0 0 15px rgba(255, 102, 204, 0.9);
          }
          .dropdown-menu .dropdown-item:hover {
            background: linear-gradient(135deg, #9933ff, #ff66cc);
            color: #ffffff;
          }
          @media (max-width: 600px) {
            /* Adjust positions for smaller screens */
            .dropdown:first-of-type {
              left: 5px !important;
              top: 5px !important;
            }
            .dropdown:last-of-type {
              right: 5px !important;
              top: 5px !important;
            }
          }
        `}
      </style>
    </>
  );
}

export default Header;
